import React, { useState } from "react";
import styled from "styled-components";
import gistLogo from "../../assets/Logos/gist_logo.svg";
import hospitalLogo from "../../assets/Logos/hospital_logo.svg";
import { useHospital } from "../HospitalContext";
import PropTypes from "prop-types";

function GisterHeader({ text, logoSrc }) {
  const hospitalContext = useHospital();
  const { hospitalData } = hospitalContext || {};
  const [logoError, setLogoError] = useState(false);
  
  // Check if we need to refresh hospital data
  if (hospitalData && hospitalData.name === 'Mayo Clinic') {
    localStorage.removeItem('hospitalData');
    window.location.reload();
  }

  const resolvedLogo = logoSrc || (hospitalData?.logo_url && !logoError ? hospitalData.logo_url : null);
  
  return (
    <Container id="coordinator-header" >
      <HospitalLogoContainer >
        {resolvedLogo ? (
          <HospitalLogo 
            src={resolvedLogo} 
            alt={`${hospitalData?.name || ''} Logo`}
            onError={() => setLogoError(true)}
          />
        ) : (
          <HospitalLogoPlaceholder>
            {hospitalData?.name || 'Hospital Logo'}
          </HospitalLogoPlaceholder>
        )}
      </HospitalLogoContainer>
      <Text>{text}</Text>
      <GistLogoContainer >
        <Logo src={gistLogo} alt="Gist Logo" />
      </GistLogoContainer>
    </Container>
  );
}

GisterHeader.propTypes = {
  children: PropTypes.node,
  text: PropTypes.string,
  logoSrc: PropTypes.string,
};

export default GisterHeader;

const Container = styled.div`
  box-shadow: 0px 2px 4px #00000029;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  background: white;
  z-index: 9999;

  height: 7.777vh;
  padding-inline: 1.57vw;
  padding-block: 0.9vh;
  font-family: 'Poppins', sans-serif;
`;

const HospitalLogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

const GistLogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Logo = styled.img`
  height: 4.4vh;
  object-fit: contain;
`;


const HospitalLogo = styled.img`
  height: 4.65vh;
  object-fit: contain;
`;

const HospitalLogoPlaceholder = styled.div`
  height: 7.4vh;
  display: flex;
  align-items: center;
  font-size: 0.8333vw;
  font-weight: bold;
  color: #666;
  padding: 0 0.926vw;
`;

const Text = styled.div`
  font-size: 1.25vw;
  color: #000000;
  font-family: 'Poppins', sans-serif;
`;
